import dynamic from 'next/dynamic'

const LazyChainAlertsPopup = dynamic(() => import('./ChainAlertsPopup'), {
  ssr: false,
})

function ChainAlertsPopup() {
  return <LazyChainAlertsPopup />
}

export default ChainAlertsPopup
